import { Card, CardContent } from "@krea/shared/design-system/Card";
import { cn } from "@krea/shared/utils";

import type { IAuditLog } from "../types";
import { JsonCodeBlock } from "./json-code-block";

interface IProps {
  detail: IAuditLog;
}

const Meta = ({ label, value }: { label: string; value: string }) => {
  return (
    <div>
      <p className="mb-1 text-label">{label}</p>
      <p className={cn("text-sm text-black")}>{value}</p>
    </div>
  );
};

export const LogDetailPane = ({ detail }: IProps) => {
  return (
    <div className="h-full overflow-y-auto bg-primary-150">
      <div className="space-y-6 p-6 sm:p-8">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <div>
              <h2 className="text-section">{detail.description}</h2>
              <p className="text-helper">
                Request ID: <span>{detail.id}</span>
              </p>
            </div>
          </div>
        </div>

        <Card>
          <CardContent>
            <h3 className="mb-4 text-subsection">Request Metadata</h3>

            <div className="grid grid-cols-1 gap-1 sm:grid-cols-2">
              <Meta
                label="Timestamp"
                value={new Date(detail.timestamp).toISOString()}
              />
              <Meta label="Action Type" value={detail.actionType} />
              {detail.lenderApplicationId && (
                <Meta
                  label="Lender Application ID"
                  value={detail.lenderApplicationId}
                />
              )}
              {detail.loanApplicationId && (
                <Meta
                  label="Loan Application ID"
                  value={detail.loanApplicationId}
                />
              )}
            </div>
          </CardContent>
        </Card>

        <JsonCodeBlock title="Request Body" value={detail.jsonRequestData} />

        <JsonCodeBlock title="Response Body" value={detail.jsonData} />
      </div>
    </div>
  );
};
